const CompanyTimeLine = [
  {
    id: 0,
    title: "we are making progress on bla bla",
    history: "5 / 30 / 2020",
    achievement:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Sit esse quibusdam porro aut, adipisci est. Animi dolorem deleniti ex numquam? Neque deleniti doloribus illo necessitatibus, blanditiis dicta officia voluptas eaque.",
  },
  {
    id: 1,
    title: "we are making progress on bla bla",
    history: "5 / 30 / 2020",
    achievement:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Sit esse quibusdam porro aut, adipisci est. Animi dolorem deleniti ex numquam? Neque deleniti doloribus illo necessitatibus, blanditiis dicta officia voluptas eaque.",
  },
  {
    id: 2,
    title: "we are making progress on bla bla",
    history: "5 / 30 / 2020",
    achievement:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Sit esse quibusdam porro aut, adipisci est. Animi dolorem deleniti ex numquam? Neque deleniti doloribus illo necessitatibus, blanditiis dicta officia voluptas eaque.",
  },
  {
    id: 3,
    title: "we are making progress on bla bla",
    history: "5 / 30 / 2020",
    achievement:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Sit esse quibusdam porro aut, adipisci est. Animi dolorem deleniti ex numquam? Neque deleniti doloribus illo necessitatibus, blanditiis dicta officia voluptas eaque.",
  },
];

export default CompanyTimeLine;
